import partition from "lodash/partition";
import { CustomValuesList } from "PFApp/components/custom_values_list/custom_values_list";
import { Divider } from "PFComponents/divider";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { Tile } from "PFComponents/tile";
import { ProfileCustomValue, PureCustomValue, SkillsFrameworkSkill } from "PFCore/types";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./skills_bulk_edit_side_panel.module.scss";

type InformationBoxProps = {
  skills: (ProfileCustomValue | SkillsFrameworkSkill)[];
};

export const InformationBox = ({ skills }: InformationBoxProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts.skillsSection.bulk" });
  const [existingSkills, missingSkills] = useMemo(
    () => partition(skills, (skill) => !!(skill as ProfileCustomValue).experience),
    [skills]
  ) as [ProfileCustomValue[], SkillsFrameworkSkill[]];

  const groups = useMemo(
    () =>
      [
        {
          id: 1,
          label: t("editing"),
          skills: existingSkills
        },
        {
          id: 2,
          label: t("adding"),
          skills: missingSkills.map<PureCustomValue>(({ skillId, value }) => ({
            id: skillId,
            text: value,
            value
          }))
        }
      ].filter(({ skills }) => skills.length > 0),
    [existingSkills, missingSkills, t]
  );

  return (
    <Tile paddingVariant="none" border>
      {groups.map(({ id, label, skills }, index) => (
        <Fragment key={id}>
          <ReadOnlyField
            key={id}
            label={label}
            classes={{ root: css.informationSection }}
            value={<CustomValuesList customValues={skills as PureCustomValue[]} limit={Infinity} compact />}
          />
          {index < groups.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Tile>
  );
};
